document.addEventListener('DOMContentLoaded', function() {
  const galleryProduct = document.querySelector('.gallery-product');
  if (!galleryProduct) return;

  const mainImage = galleryProduct.querySelector('.gallery-product__featured-image');
  const mainImageLink = galleryProduct.querySelector('.gallery-lightbox-trigger');
  const thumbnails = galleryProduct.querySelectorAll('.gallery-thumbnail-trigger');
  const thumbnailContainers = galleryProduct.querySelectorAll('.gallery-product__thumbnail');

  // Handle thumbnail clicks for main image switching
  thumbnails.forEach((thumbnail, index) => {
    thumbnail.addEventListener('click', function(e) {
      // Don't prevent default as we want the lightbox to work
      e.stopPropagation();
      
      // Update main image
      const newImageSrc = this.getAttribute('data-image-medium') || this.getAttribute('data-image');
      const newImageSrcset = `${this.getAttribute('data-image-small')} 800w, 
                              ${this.getAttribute('data-image-medium')} 1200w, 
                              ${this.getAttribute('data-image-large')} 2000w`;
      const newImageAlt = this.querySelector('img').alt;
      
      if (mainImage && newImageSrc) {
        // Add loading state
        mainImage.style.opacity = '0';
        
        // Update main image after short delay for smooth transition
        setTimeout(() => {
          mainImage.src = newImageSrc;
          mainImage.srcset = newImageSrcset;
          mainImage.alt = newImageAlt;
          
          // Update main image lightbox data
          if (mainImageLink) {
            mainImageLink.setAttribute('data-image', this.getAttribute('data-image'));
            mainImageLink.setAttribute('data-image-small', this.getAttribute('data-image-small'));
            mainImageLink.setAttribute('data-image-medium', this.getAttribute('data-image-medium'));
            mainImageLink.setAttribute('data-image-large', this.getAttribute('data-image-large'));
          }
          
          // Update active thumbnail
          thumbnailContainers.forEach(container => container.classList.remove('active'));
          this.closest('.gallery-product__thumbnail').classList.add('active');
          
          // Fade back in
          mainImage.style.opacity = '1';
        }, 150);
      }
    });

    // Preload images on hover for better performance
    thumbnail.addEventListener('mouseenter', function() {
      const imageToPreload = this.getAttribute('data-image-medium');
      if (imageToPreload) {
        const img = new Image();
        img.src = imageToPreload;
      }
    });
  });

  // Enhanced keyboard navigation for thumbnails
  thumbnails.forEach((thumbnail, index) => {
    thumbnail.addEventListener('keydown', function(e) {
      let targetIndex;
      
      switch(e.key) {
        case 'ArrowRight':
        case 'ArrowDown':
          targetIndex = index + 1 >= thumbnails.length ? 0 : index + 1;
          e.preventDefault();
          break;
        case 'ArrowLeft':
        case 'ArrowUp':
          targetIndex = index - 1 < 0 ? thumbnails.length - 1 : index - 1;
          e.preventDefault();
          break;
        case 'Home':
          targetIndex = 0;
          e.preventDefault();
          break;
        case 'End':
          targetIndex = thumbnails.length - 1;
          e.preventDefault();
          break;
        default:
          return;
      }
      
      if (targetIndex !== undefined) {
        thumbnails[targetIndex].focus();
      }
    });
  });

  // Smooth scroll for mobile thumbnails
  const thumbnailContainer = galleryProduct.querySelector('.gallery-product__thumbnails');
  if (thumbnailContainer && window.innerWidth <= 989) {
    let isScrolling = false;
    
    thumbnailContainer.addEventListener('scroll', function() {
      if (!isScrolling) {
        window.requestAnimationFrame(function() {
          // Add scrolling class for visual feedback
          thumbnailContainer.classList.add('scrolling');
          
          setTimeout(() => {
            thumbnailContainer.classList.remove('scrolling');
          }, 150);
          
          isScrolling = false;
        });
        isScrolling = true;
      }
    });
  }

  // Intersection Observer for lazy loading and animations
  if ('IntersectionObserver' in window) {
    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          
          // Add loaded class for any custom styling
          img.classList.add('loaded');
          
          // Stop observing this image
          observer.unobserve(img);
        }
      });
    }, {
      rootMargin: '50px 0px',
      threshold: 0.1
    });

    // Observe all gallery images
    const galleryImages = galleryProduct.querySelectorAll('img');
    galleryImages.forEach(img => {
      imageObserver.observe(img);
    });
  }

  // Add touch gestures for mobile
  if ('ontouchstart' in window) {
    let touchStartX = 0;
    let touchStartY = 0;
    
    mainImage.addEventListener('touchstart', function(e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
    });
    
    mainImage.addEventListener('touchend', function(e) {
      if (!touchStartX || !touchStartY) return;
      
      const touchEndX = e.changedTouches[0].clientX;
      const touchEndY = e.changedTouches[0].clientY;
      
      const diffX = touchStartX - touchEndX;
      const diffY = touchStartY - touchEndY;
      
      // Only process horizontal swipes with sufficient distance
      if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 50) {
        const activeIndex = Array.from(thumbnailContainers).findIndex(t => t.classList.contains('active'));
        
        if (diffX > 0 && activeIndex < thumbnails.length - 1) {
          // Swipe left - next image
          thumbnails[activeIndex + 1].click();
        } else if (diffX < 0 && activeIndex > 0) {
          // Swipe right - previous image
          thumbnails[activeIndex - 1].click();
        }
      }
      
      touchStartX = 0;
      touchStartY = 0;
    });
  }

  // Performance optimization: debounce resize events
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      // Recalculate image dimensions if needed
      const images = galleryProduct.querySelectorAll('img');
      images.forEach(img => {
        if (img.complete) {
          img.style.opacity = '1';
        }
      });
    }, 250);
  });

  // Add loading states for better UX
  const addLoadingState = (element) => {
    element.style.opacity = '0.7';
    element.style.transition = 'opacity 0.3s ease';
  };

  const removeLoadingState = (element) => {
    element.style.opacity = '1';
  };

  // Apply loading states to main image
  if (mainImage) {
    addLoadingState(mainImage);
    
    if (mainImage.complete) {
      removeLoadingState(mainImage);
    } else {
      mainImage.addEventListener('load', () => removeLoadingState(mainImage));
    }
  }
});